import { useEffect, useRef } from 'react'

export function useKeybindingControl(onKeyPressed: (e: KeyboardEvent) => void) {
  const onKeyPressedTunnel = useRef(onKeyPressed)
  onKeyPressedTunnel.current = onKeyPressed
  useEffect(() => {
    const handler = (e: KeyboardEvent) => onKeyPressedTunnel.current(e)
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])
}
